import { render } from "./Assistant.vue?vue&type=template&id=4a6232b2&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"

import "./Assistant.vue?vue&type=style&index=0&id=4a6232b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6232b2"]])

export default __exports__